import React from 'react';
import TextBlock from 'components/common/helpMeDecide/TextBlock';
import withCriteria from 'components/common/helpMeDecide/withCriteria';
import { RadioGroup } from '@insurancemenu/imenu-components-lib';
import { createStyles } from 'components/common/helpMeDecide/commonCriteriaStyles';
import { observer } from 'mobx-react-lite';
import { useRootStore } from 'store/rootStore';

const DentalCriteria3 = observer((): JSX.Element => {
  const classes = createStyles();

  // Mobx store
  const {
    browsingFilterStore: { onBrowsingCriteriaChange, getBrowsingCriteriaValue },
  } = useRootStore();

  const bcName = 'orthoCoverageLevel';

  // Values for radio buttons group
  const radioButtons = [
    {
      id: 'coverage-children',
      label: 'Dependent children to age 19',
      value: 'child',
    },
    {
      id: 'coverage-children-and-adults',
      label: 'Dependent children to age 26 and adults',
      value: 'adult_child',
    },
  ];

  return (
    <div>
      <TextBlock
        title="Orthodontics Coverage Level"
        subtitle="Coverage may apply for dependent children to age 19 only, or also adults and dependent children to age 26."
      />
      <RadioGroup
        label=""
        value={getBrowsingCriteriaValue(bcName)}
        radioButtons={radioButtons}
        className={classes.radioButtonGroup}
        onChange={(e: React.ChangeEvent<HTMLInputElement>): void => {
          onBrowsingCriteriaChange(bcName, e.target.value);
        }}
      />
    </div>
  );
});

export default withCriteria(DentalCriteria3, 3);
